@if (isLoading) {
  <loader [config]="{
    fullScreen: false,
    overlay: true,
    type: 'spinner',
    size: 'md',
    text: 'Loading...'
  }"/>
}
@if (alertInfo.show) {
  <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
    {{ alertInfo.message }}
  </ngb-alert>
}

<form [formGroup]="form">
  <div class="row g-3">

    <div class="col-md-6">
      <div class="card shadow-sm h-100">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h3 class="card-title mb-0">Data</h3>
        </div>
        <div class="card-body">

          <div class="mb-3">
            <input-field
              type="text"
              [inputFormControl]="getNameInput()"
              label="Name"
              placeholder="Name"
            />
          </div>

          <div class="row g-2 mb-3">
            <div class="col-12 col-sm-5">
              <input-field
                type="text"
                [inputFormControl]="getAddressInput()"
                label="Address"
                placeholder="Address"
              />
            </div>
            <div class="col-6 col-sm-3">
              <input-field
                type="text"
                [inputFormControl]="getZipCodeInput()"
                label="Zip code"
                placeholder="Zip code"
              />
            </div>
            <div class="col-6 col-sm-4">
              <input-field
                type="text"
                [inputFormControl]="getCityInput()"
                label="City"
                placeholder="City"
              />
            </div>
          </div>

          <div class="mb-3" style="max-width: 240px;">
            <input-field
              type="text"
              [inputFormControl]="getVatInput()"
              label="VAT"
              placeholder="VAT"
            />
          </div>

          <hr class="my-3" />

          <div class="d-flex gap-3 flex-wrap align-items-center">

            <div class="d-flex flex-column" style="min-width: 150px; flex: 1;">
              <label class="fw-bold">Starting date</label>
              <div class="input-group shadow-sm mt-1">
                <input
                  type="date"
                  class="form-control"
                  [formControl]="getContractStartTimeInput()"
                  [ngClass]="{
                    'is-invalid': getContractStartTimeInput().invalid && (getContractStartTimeInput().touched || getContractStartTimeInput().dirty),
                    'is-valid':   getContractStartTimeInput().valid   && (getContractStartTimeInput().touched || getContractStartTimeInput().dirty)
                  }"
                />
              </div>
              @if (getContractStartTimeInput().invalid && (getContractStartTimeInput().touched || getContractStartTimeInput().dirty)) {
                <div class="text-danger small mt-1">
                  @if (getContractStartTimeInput().errors?.['required']) {
                    <span><i class="fa fa-exclamation-circle me-1"></i>Required field</span>
                  }
                </div>
              }
            </div>

            <div class="d-flex flex-column" style="min-width: 200px; flex: 1;">
              <label class="fw-bold">Upload signed contract</label>

              @if (!activeContractName) {
                <div class="mt-1">
                  <button type="button" class="btn btn-primary" (click)="contractInput.click()">
                    <i class="fa fa-plus me-1"></i> Add contract
                  </button>
                  <input
                    #contractInput
                    type="file"
                    style="display: none"
                    accept="application/pdf,image/*"
                    (change)="onContractSelected($event)"
                  />
                </div>
              }

              @if (activeContractName) {
                <div class="card mt-1">
                  <div class="card-body d-flex align-items-center py-2 px-3">
                    <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                      <i class="fa fa-file text-primary me-2 flex-shrink-0"></i>
                      <span class="text-truncate">{{ activeContractName }}</span>
                    </div>
                    <div class="d-flex gap-2 ms-2 flex-shrink-0">
                      @if (hasExistingContract) {
                        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="viewContract()" title="View file">
                          <i class="fa fa-eye"></i>
                        </button>
                      }
                      <button type="button" class="btn btn-outline-danger btn-sm" (click)="confirmRemoveContract()" title="Remove contract">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              }

            </div>

          </div>

        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="card shadow-sm h-100">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h3 class="card-title mb-0">Commission</h3>
        </div>
        <div class="card-body">
          @if (isLoadingCommissions) {
            <loader [config]="{ fullScreen: false, overlay: false, type: 'spinner', size: 'sm', text: 'Loading...' }"/>
          } @else {
            <introducer-commission
              [commissions]="commissions"
              [introducerId]="introducer?.introducerId"
              (commissionsChange)="commissions = $event"
            />
          }
        </div>
      </div>
    </div>

  </div>

  <div class="d-flex justify-content-center gap-3 mt-4">
    <button type="button" class="btn btn-secondary px-4 py-2" (click)="goBack()">
      Cancel
    </button>
    <button type="button" class="btn btn-success px-4 py-2" (click)="submitForm()">
      Save
    </button>
  </div>
</form>
